import React, { useEffect } from 'react';
import SuccessStories from '../components/SuccessStories';
import Contact from '../components/Contact';

const SuccessStoriesPage: React.FC = () => {
  useEffect(() => {
    document.title = 'Nutanix Success Stories | TNCOSOFT - Global Infrastructure Transformations';
    
    // Update meta description
    const metaDescription = document.querySelector('meta[name="description"]');
    if (metaDescription) {
      metaDescription.setAttribute(
        'content',
        'Discover how leading global organizations across Automotive, Financial Services, and IT industries have transformed their infrastructure with Nutanix Cloud Platform. Real-world success stories with measurable business outcomes.'
      );
    }
  }, []);

  return (
    <>
      <SuccessStories />
      <Contact />
    </>
  );
};

export default SuccessStoriesPage;
